import {
  Grid,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
} from "@mui/material";
import _ from "lodash";

const ProductList = ({
  productList,
  order,
  formatCurrency,
  currencySymbol,
}) => {
  return (
    <>
      {" "}
      <Grid item container spacing={2} xs={12} sm={12} md={12} lg={12}>
        {productList.map((product, i) => (
          <Grid item xs={12} sm={12} md={12} lg={12} key={i}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                // py: 2,
                borderBottom: "0.2px solid #e5e5e5",
                // background:"#e5e5e5"
              }}
            >
              <Grid xs={5} md={2} lg={2}>
                {_.get(product, "product_detail.images[0].image") ? (
                  <Box
                    sx={{
                      width: {
                        xs: 70,
                        sm: 90,
                        md: 100,
                      },
                      height: "100%",
                      mr: 2,
                      flexShrink: 0,
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={_.get(
                        product,
                        "product_detail.images[0].image",
                        "",
                      )}
                      alt={_.get(product, "product_detail.product_name", "")}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                  </Box>
                ) : (
                  <Box
                    sx={{
                      height: {
                        xs: "100%",
                        sm: "100%",
                        md: "100%",
                        lg: "100%",
                      },
                      width: { xs: "100%", sm: "100%", md: "100%", lg: "100%" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "rgba(0, 0, 0, 0.05)",
                      border: "1px dashed rgba(0, 0, 0, 0.2)",
                    }}
                  >
                    <Typography variant="body2" color="textSecondary">
                      No Image
                    </Typography>
                  </Box>
                )}
              </Grid>
              <Grid xs={8} lg={8}>
                <Box sx={{ flex: 1 }}>
                  <Box>
                    <Typography
                      sx={{ fontSize: "var(--fs-sm)", fontWeight: "500" }}
                      noWrap
                    >
                      {_.get(product, "product_detail.product_name")
                        ? _.truncate(
                            _.get(product, "product_detail.product_name"),
                            { length: 25 },
                          )
                        : `Product ID: ${product.product_id || "N/A"}`}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontSize: "var(--fs-xs)",
                        color: "var(--text-gray)",
                      }}
                      // color="textSecondary"
                    >
                      Qty: {product.quantity}
                    </Typography>
                    {console.log("product details", product)}
                    {product?.product_detail?.size?.name &&
                      product?.product_detail?.size?.name !== "" &&
                      product?.product_detail?.size?.name !== "null" && (
                        <Typography
                          sx={{
                            fontSize: "var(--fs-xs)",
                            color: "var(--text-gray)",
                          }}
                        >
                          Size: {product?.product_detail?.size?.name}
                        </Typography>
                      )}
                    {product?.product_detail?.color?.name &&
                      product?.product_detail?.color?.name !== "" &&
                      product?.product_detail?.color?.name !== "null" && (
                        <Typography
                          sx={{
                            fontSize: "var(--fs-xs)",
                            color: "var(--text-gray)",
                          }}
                        >
                          Color: {product?.product_detail?.color?.name}
                        </Typography>
                      )}
                    <Typography
                      sx={{
                        fontSize: "var(--fs-xs)",
                        color: "var(--text-gray)",
                      }}
                    >
                      {product.delivery_status_type}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "var(--fs-xs)",
                        color: "var(--text-gray)",
                      }}
                    >
                      {order.selected_payment_mode.Name}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{ fontSize: "var(--fs-sm)", fontWeight: "600" }}
                      mb={2}
                    >
                      {currencySymbol} {_.get(product, "total_price", 0)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Box>
            <Divider />
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default ProductList;
